import { Link } from 'react-router-dom'
import { Card } from '@/components/ui/card'
import { useDashboard } from '../useDashboard'

interface QuickLink {
	label: string
	href: string
}

const LINKS: QuickLink[] = [
	{ label: 'Request Types', href: '/admin/request-center/types' },
	{ label: 'Data Sources', href: '/admin/request-center/data-sources' },
	{ label: 'Systems', href: '/admin/request-center/systems' },
	{ label: 'Audit Search', href: '/admin/request-center/audit' },
]

/**
 * Admin-only Quick Links — static shortcuts to the Request Center
 * admin pages. No data fetches; just navigation.
 *
 * Spec 4 / Group 9f — `request-center-dashboard.md`.
 */
export function QuickLinksWidget() {
	const { isAdminViewer } = useDashboard()
	if (!isAdminViewer) return null

	return (
		<Card className="p-4">
			<h2 className="mb-3 text-sm font-semibold text-gray-700">Quick Links</h2>
			<ul className="grid grid-cols-2 gap-2">
				{LINKS.map((l) => (
					<li key={l.href}>
						<Link
							to={l.href}
							className="block rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:border-gray-300 hover:bg-gray-50"
						>
							{l.label}
						</Link>
					</li>
				))}
			</ul>
		</Card>
	)
}
